import { StarSmall } from '@icons/StarSmall';
import { StarSmallOutline } from '@icons/StarSmallOutline';

export interface IStarSmalls {
  isFilled: boolean;
}

export const StarSmalls = ({ isFilled }: IStarSmalls) => {
  return (
    <span aria-hidden="true" className="Star">
      <div className="p-1">{isFilled ? <StarSmall /> : <StarSmallOutline />}</div>
    </span>
  );
};
